module.exports = __webpack_public_path__ + "static/logo_name-8857dcbf65dd9507f0d290ed1552b9ba.png";